var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.002,
    height: 29.004,
    viewBox: "0 0 20.002 29.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Sottrazione_32",
    "data-name": "Sottrazione 32",
    d: "M18129-15731h-6a1,1,0,0,1-1-1v-1h8v1A1,1,0,0,1,18129-15731Zm1.5-6h-9a1,1,0,0,1-1-1v-3.65l-.213-.15a10.047,10.047,0,0,1-4.289-8.2,10.012,10.012,0,0,1,10-10,10.013,10.013,0,0,1,10,10,10.039,10.039,0,0,1-4.289,8.2l-.209.15v3.65A1,1,0,0,1,18130.5-15737Zm-4.5-21a8.005,8.005,0,0,0-8,8,8,8,0,0,0,3.436,6.56l1.061.751v3.691h7v-3.691l1.061-.747A8.016,8.016,0,0,0,18134-15750,8.009,8.009,0,0,0,18126-15758Z",
    transform: "translate(-18115.998 15760.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.aa5ad7a74866ec2de2aa762478fc7803.svg";
export { ForwardRef as ReactComponent };